/** Адреса поиска для продажи общего каталога Platform (RMK-CATALOG 2.2). Литерал `/api/` законен только здесь. */
export const OWN_CATALOG_URLS = {
  /** `GET ?resourceId=&q=&mode=text|barcode&limit=&page=`: право `session.open` на ресурсе-кассе. */
  saleSearch: () => '/api/platform/v1/catalog/sale-search',
} as const

/** Адреса продажи службы Resource.Own (право `session.open` на ресурсе). Литерал `/api/` — только здесь. */
const resource = (resourceId: string) => `/api/own/v1/resources/${encodeURIComponent(resourceId)}`

export const OWN_SALE_URLS = {
  /** `GET`: настройки продажи, которые кассиру можно знать (вид цены по умолчанию). */
  saleSettings: (resourceId: string) => `${resource(resourceId)}/sale-settings`,
  /** `POST { cardKeys, priceTypeKey? }`: цена и ставка НДС строк для продажи. Чтение, эффекта нет. */
  saleLines: (resourceId: string) => `${resource(resourceId)}/sale-lines`,
} as const
